export default {
  inputPlaceholder: 'дд.мм.гггг',
};
